
<template>
  <div>
    <!-- DIALOG PARA PRE VISUALIZAÇÃO DO ANEXO -->
    <v-dialog v-model="local_dialog" v-if="attached_file_url || local_file_preview?.url">
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Visualização do anexo</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3 " style="max-height: 75.5vh ; overflow-y: auto" >
          <template v-if="is_pdf">
            <iframe :src="preview_url" title="Anexo PDF" style="width: 100%; height: 70vh; border: 0;"></iframe>
            <div class="text-center mt-3">
              <a :href="preview_url" target="_blank" rel="noopener">Abrir PDF em nova aba</a>
            </div>
          </template>
          <img v-else width="100%" :src="preview_url"/>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn close @click="local_dialog = false"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'DialogSeeAttachment',
  props: {
    attached_file_url: {
      type: String,
      default: null
    },
    local_file_preview: {
      type: Object,
      default: null
    },
    dialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      local_dialog: false,
    }
  },
  computed: {
    preview_url() {
      return this.attached_file_url || this.local_file_preview?.url || ''
    },
    is_pdf() {
      const name = this.local_file_preview?.name || ''
      const type = this.local_file_preview?.type || ''
      if (type === 'application/pdf') return true
      const source = name || this.preview_url
      const path = String(source).split('?')[0].split('#')[0]
      return path.toLowerCase().endsWith('.pdf')
    },
  },
  watch:{
    dialog(){
      this.local_dialog = true
    }
  }
}
</script>